import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { validFee } from '../lib/deliveryPricing';
import { PageHeader } from './shared';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { money } from '../lib/constants';

export default function AdminPackagePricing() {
  const { packagePricing, savePackagePricing } = useApp();
  const [draft, setDraft] = useState({});
  const [busy, setBusy] = useState(false);
  const values = { ...packagePricing, ...draft };
  const save = async (event) => {
    event.preventDefault();
    if (!validFee(values.basePrice) || !validFee(values.pricePerKm) || values.includedKm === '' || !Number.isFinite(Number(values.includedKm)) || Number(values.includedKm) < 0) return toast.error('Revisa las tarifas y los kilómetros incluidos');
    setBusy(true);
    try { await savePackagePricing({ basePrice: Number(values.basePrice), includedKm: Number(values.includedKm), pricePerKm: Number(values.pricePerKm) }); setDraft({}); toast.success('Tarifas de encomiendas guardadas'); }
    catch { /* Context displays errors. */ } finally { setBusy(false); }
  };
  return <div>
    <PageHeader title="Tarifas de encomiendas" subtitle="Recogida y entrega de paquetes" />
    <form onSubmit={save} className="max-w-3xl space-y-6">
      <div className="grid sm:grid-cols-3 gap-5">
        {[['basePrice', 'Precio base (L)', '0.01'], ['includedKm', 'Kilómetros incluidos', '0.001'], ['pricePerKm', 'Cada km adicional (L)', '0.01']].map(([key, label, step]) => <div key={key} className="space-y-2"><Label htmlFor={`package-${key}`}>{label}</Label><Input id={`package-${key}`} data-testid={`package-${key}`} type="number" min="0" step={step} max={key === 'includedKm' ? 20000 : undefined} required disabled={!packagePricing || busy} value={values[key] ?? ''} onChange={(e) => setDraft({ ...draft, [key]: e.target.value })} /></div>)}
      </div>
      <div data-testid="package-pricing-rule" className="border-y border-gray-200 py-5 space-y-2 text-sm">
        <p className="font-semibold">Base + distancia adicional + zona de recogida + zona de entrega</p>
        <p className="text-gray-500">Distancia en línea recta · Tarifas independientes de restaurantes y Mandaditos 7</p>
        {packagePricing && <p data-testid="package-saved-pricing" className="font-semibold">{money(packagePricing.basePrice)} base · {packagePricing.includedKm} km incluidos · {money(packagePricing.pricePerKm)} / km adicional</p>}
        <Link data-testid="package-area-rates-link" to="/admin/zonas" className="inline-block text-[#2F80ED] font-semibold">Adicionales por zona</Link>
      </div>
      <Button data-testid="package-pricing-save" type="submit" disabled={!packagePricing || busy} className="bg-[#EE3B36] hover:bg-[#D93129] gap-2"><Save size={16} />{busy ? 'Guardando…' : 'Guardar tarifas de encomiendas'}</Button>
    </form>
  </div>;
}